export const companiesCompanyIdMobileAppLinkingAssignableTrackingDomains =
  "/companies/:company_id/mobile_app_linking_assignable_tracking_domains";
